import { EntitySwitch, isComponentType } from '@backstage/plugin-catalog';
import { serviceEntityPage } from './serviceEntityPage';
import { libraryEntityPage } from './libraryEntityPage';
import { documentationEntityPage } from './documentationEntityPage';
import { mobileEntityPage } from './mobileEntityPage';
import { defaultEntityPage } from './defaultEntityPage';

export const componentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>
      {serviceEntityPage}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType('website')}>
      {serviceEntityPage}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType('library')}>
      {libraryEntityPage}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType('mobile')}>
      {mobileEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('documentation')}>
      {documentationEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
